import styled from 'styled-components';

export const GlobalFloatingPillWrapper = styled.div`
  [class*='Button-sc'] {
    position: fixed;
    bottom: 120px;
    right: 120px;
    border-radius: 50px;
    padding: 10px 20px;
    z-index: 10;

    @media (max-width: 768px) {
      right: 30px;
      width: fit-content;
    }
  }
`;
